import type { CartItem } from '@/context/CartContext';

export type CatalogProductSnapshot = {
  id: string;
  name: string;
  brand: string;
  barcode: string;
  salePrice: number;
  stock: number;
  unit?: string;
};

export function syncCartItemWithProduct(item: CartItem, product: CatalogProductSnapshot): CartItem {
  if (item.productId !== product.id || item.isManualProduct) return item;

  const keepsManualPrice = item.isPriceEdited && item.salePrice !== product.salePrice;
  return {
    ...item,
    productName: product.name,
    brand: product.brand,
    barcode: product.barcode,
    stock: product.stock,
    unit: product.unit,
    salePrice: keepsManualPrice ? item.salePrice : product.salePrice,
    originalSalePrice: keepsManualPrice ? product.salePrice : undefined,
    isPriceEdited: keepsManualPrice,
  };
}
